import { render, staticRenderFns } from "./searchBody.vue?vue&type=template&id=1bc6e964&functional=true&"
import script from "./searchBody.vue?vue&type=script&lang=js&"
export * from "./searchBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports